import Layout from "./layout";
import { Button, Box } from "@mui/material";
import { useNavigate } from 'react-router-dom';// Page linking using this 

const CreateEventandStaffDash = () => {
    const navigate = useNavigate();// Page linking using this 


    return( 
        <>  
        <Layout/>
        <h1 className="title">Issue Products for Event</h1>
        <Box
                sx={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '50vh', gap: '8em', }}
            >    
                <Button 
                    variant="contained"
                    onClick={() => {navigate('/issue-eventsmain') }}
                    sx={{backgroundColor: '#0A64A2', color: '#fff',left:'2em', borderRadius:'0.4em' ,marginRight: '2em',padding: '35px 70px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                      }}
                >
                   Create Event
                </Button>
                
                <Button
                    variant="contained" onClick={() => {navigate('/issue-eventsmain2') }} // Page linking using this 
                    sx={{backgroundColor: '#0A64A2',color: '#fff',padding: '37px 37px',fontSize: '14px',borderRadius:'0.4em' ,fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                 Issue Products for Event
                </Button>
            </Box>

        </>
    )
}
export default CreateEventandStaffDash;   

